module.exports = __webpack_public_path__ + "img/signup-guide-05-03.854efb8a.png";